import { ContentfulImage } from '@components/contentful-image'
import type { BlockFragment } from '@graphql/fragments/BlockFragment.graphql'
import { LocalLink } from '@shared/util/link'
import variables, { type Variable } from '@styles/variables'
import Link from 'next/link'
import { useRouter } from 'next/router'
import type { FunctionComponent } from 'react'

import styles from './block.module.scss'
import TextBlock from './text-block'

/**
 * Section that displays a block for the 9 block grid.
 */

export const Block: FunctionComponent<Props> = ({
    titleMd = '',
    subtitleMd = '',
    subtextTopMd = '',
    image = null,
    backgroundColor = 'black',
    isCenterBlock = false,
    path = '',
}) => {
    const router = useRouter()
    const isNavigable = !isCenterBlock && path !== ''

    function getBackgroundStyle() {
        return {
            backgroundColor: variables[backgroundColor as Variable],
            cursor: isNavigable ? 'pointer' : 'auto',
        }
    }

    const content = (
        <div>
            {image?.url && (
                <div
                    className={`${styles.imageContainer} ${
                        isCenterBlock ? styles.centerBlockImageContainer : ''
                    }`}
                >
                    <ContentfulImage
                        url={image.url}
                        fill
                        alt={image?.alt}
                        contentType={image.contentType}
                        sizes='70px'
                        className={`${styles.image} ${
                            isCenterBlock ? styles.centerBlockImage : ''
                        }`}
                    />
                </div>
            )}

            <TextBlock textField={subtextTopMd} isCenterBlock={isCenterBlock} />
            <TextBlock textField={titleMd} isCenterBlock={isCenterBlock} />
            <TextBlock textField={subtitleMd} isCenterBlock={isCenterBlock} />
        </div>
    )

    if (isNavigable) {
        const link = new LocalLink({ base: path })
        return (
            <Link
                href={link.serialize(router)}
                className={styles.item}
                style={getBackgroundStyle()}
            >
                {content}
            </Link>
        )
    }

    return (
        <div className={styles.item} style={getBackgroundStyle()}>
            {content}
        </div>
    )
}

export default Block

type Props = Omit<BlockFragment, 'sys' | 'type'>
